(() => {
  if (customElements.get('horizontal-scroll-progress')) return;

  class HorizontalScrollProgress extends HTMLElement {
    connectedCallback() {
      this.targetId = this.dataset.target;
      this.itemSelector = this.dataset.itemSelector || ':scope > *';
      this.rail = this.targetId ? document.getElementById(this.targetId) : null;
      if (!this.rail) return;

      this.value = this.querySelector('.horizontal-scroll-progress__value');
      if (!this.value) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.rail.addEventListener('scroll', () => this.requestUpdate(), { passive: true, signal });
      window.addEventListener('resize', () => this.requestUpdate(), { passive: true, signal });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this.rail);
      }

      this.mutationObserver = new MutationObserver(() => this.requestUpdate());
      this.mutationObserver.observe(this.rail, { childList: true, subtree: true });
      this.requestUpdate();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    requestUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      if (!this.rail || !this.value) return;

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const scrollableWidth = Math.max(this.rail.scrollWidth - this.rail.clientWidth, 0);
      const hasOverflow = scrollableWidth > 1;
      this.hidden = !isMobile || !hasOverflow;
      if (this.hidden) return;

      const firstItem = this.rail.querySelector(this.itemSelector);
      const railRect = this.rail.getBoundingClientRect();
      const firstRect = firstItem?.getBoundingClientRect();
      const isRtl = getComputedStyle(this.rail).direction === 'rtl';
      const scrollOffset = firstRect
        ? isRtl
          ? Math.max(firstRect.right - railRect.right, 0)
          : Math.max(railRect.left - firstRect.left, 0)
        : Math.abs(this.rail.scrollLeft);
      const visibleProgress = this.rail.scrollWidth > 0 ? this.rail.clientWidth / this.rail.scrollWidth : 1;
      const scrollProgress = Math.min(scrollOffset / scrollableWidth, 1);
      const progress = Math.min(visibleProgress + scrollProgress * (1 - visibleProgress), 1);

      this.value.style.setProperty('--horizontal-scroll-progress', progress.toFixed(4));
    }
  }

  customElements.define('horizontal-scroll-progress', HorizontalScrollProgress);
})();
